module.exports = __webpack_public_path__ + "static/media/railway-station.5532faec.svg";